import { Fragment } from 'react';
import { Route } from 'react-router-dom';
import TestPlayer from '../components/Player/TestPlayer';
import { version } from '../utils/packageJson.js';
import APIEndpointTesting from '../components/APIEndpointTesting';
import preval from 'preval.macro';
import { usePathTo } from './route-utils';
import Settings from '../views/settings/Settings';

export function UtilityRoutes() {
  return (
    <Fragment>
      <Route path={usePathTo('/altiboxtestplayer')} component={TestPlayer} exact />

      <Route
        path={usePathTo('/version')}
        render={() => (
          <div className="light">
            <p>
              Version: {version} - {process.env.REACT_APP_VERSION}
            </p>
            <p>Build Date: {preval`module.exports = new Date().toLocaleString('nb-NO', { hour12: false });`}.</p>
          </div>
        )}
        exact
      />
      <Route
        path={usePathTo('/font')}
        render={() => (
          <>
            <h1>Altibox Regular</h1>
            <div style={{ fontSize: '2em', fontFamily: 'Altibox-Regular' }}>
              |1234567890+\qwertyuiopåäsdfghjkløæ'zxcvbnm,.- §!"#¤%/()=?WERTYUIOPÅÂSDFGHJKLØÆ*{'>'}
              ZXCVBNM;:_" ¦¡@£$½¥[]±ł€®þ←↓→œπßðđŋħł½«»©“”nµ–ɎąĂëĎĄŇÏŔ
            </div>
            <h1>Altibox STB</h1>
            <div style={{ fontSize: '2em', fontFamily: 'Altibox-STB' }}>
              |1234567890+\qwertyuiopåäsdfghjkløæ'zxcvbnm,.- §!"#¤%/()=?WERTYUIOPÅÂSDFGHJKLØÆ*{'>'}
              ZXCVBNM;:_" ¦¡@£$½¥[]±ł€®þ←↓→œπßðđŋħł½«»©“”nµ–✚⚊ɎąĂëĎ
            </div>
          </>
        )}
      />
      {<Route path={usePathTo('/api-test/:payload')} component={APIEndpointTesting} />}
      {<Route path={usePathTo('/api-test')} component={APIEndpointTesting} />}
      {<Route path={usePathTo('/settings')} component={Settings} />}
    </Fragment>
  );
}
